import { Chip, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import TvFilledIcon from '../../../../components/Icons/TvFilledIcon';
import { isAdminRole, isAgencyRole } from '../../../../helpers/roles';

const ClientChip = styled(Chip)({
  maxHeight: '29px',
  borderRadius: '32px',
  color: '#2E2C34',
  fontWeight: 600,
  fontSize: 12,
  '& .tv-filled-icon': {
    margin: '0 -8px -2px 10px',
    color: '#1B4332',
    width: 13,
  },
});

const ExpandChip = styled(ClientChip)({
  color: '#1B4332',
});

const Clients = ({ userRole = {}, clients }) => {
  const [displayAllClients, setDisplayAllClients] = useState(clients?.length <= 2);
  if (isAdminRole(userRole.value) || isAgencyRole(userRole.value)) {
    return <div className='pl-5'>&mdash;</div>;
  }

  if (!clients?.length) return null;

  const visibleClients = displayAllClients ? clients.slice() : clients.slice(0, 2);

  const visibleChips = visibleClients.map((client, i) => (
    <ClientChip key={i} icon={<TvFilledIcon />} variant='outlined' label={client?.label} />
  ));

  if (!displayAllClients) {
    visibleChips.push(
      <ExpandChip
        key={clients.length + 1}
        variant='outlined'
        label={`+${clients.length - 2}`}
        onClick={() => setDisplayAllClients(true)}
      />,
    );
  }
  return <div className='flex gap-x-[6px] gap-y-[3px]'>{visibleChips}</div>;
};

Clients.propTypes = {
  userRole: PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  clients: PropTypes.array,
};

export default Clients;
